import React, { useEffect, useState } from "react";
import styled from "styled-components";
import moment from "moment";
import {useGetZones} from "../pages-lib/view-zones/model";

export default function ViewZones() {
    const [map, setMap] = useState(null);
    const { items } = useGetZones();

    useEffect(() => {
        if (window.ymaps) {
            window.ymaps.ready(initMap);
        }
    }, []);

    const initMap = () => {
        const mapInstance = new window.ymaps.Map("yandex-map", {
            center: [59.93863, 30.31413],
            zoom: 11,
            controls: ["zoomControl"],
        }, {
            suppressMapOpenBlock: true,
        });

        const searchControl = new window.ymaps.control.SearchControl({
            options: {
                noCentering: true,
                provider: 'yandex#map',
                noPlacemark: false,
                placeholderContent: 'Найти место...',
                size: 'large'
            }
        });

        mapInstance.controls.add(searchControl);

        setMap(mapInstance);
    };

    useEffect(() => {
        if (!map || items.length === 0) return;

        items.forEach(point => {
            if (point.deliveryZones.length === 0) return;

            if (point.latitude && point.longitude) {
                const placemark = new window.ymaps.Placemark(
                    [point.latitude, point.longitude],
                    {
                        hintContent: point.shortName?.[0]?.content || "Точка",
                        balloonContent: `
                            <strong>${point.shortName?.[0]?.content || "Точка доставки"}</strong><br />
                            ${point.addressString || ""}
                        `,
                    },
                    {
                        preset: "islands#blueDotIcon",
                        draggable: false,
                    }
                );
                map.geoObjects.add(placemark);
            }

            point.deliveryZones.forEach(zone => {
                if (!zone.geojson) return;

                let parsedGeojson;
                try {
                    parsedGeojson = JSON.parse(zone.geojson);
                } catch (e) {
                    console.warn("❌ Ошибка парсинга geojson:", zone.geojson);
                    return;
                }

                if (parsedGeojson?.geometry?.type === "Polygon") {
                    const fixedCoordinates = parsedGeojson.geometry.coordinates.map(ring =>
                        ring.map(([lon, lat]) => [lat, lon])
                    );

                    const fillColor = parsedGeojson.properties?.fillColor || "#1bad03";

                    const {
                        name,
                        description,
                        timeForHurryUp,
                        currentTimeForHurryUp,
                        timeForKitchen,
                        currentTimeForKitchen,
                        isActiveHurryUpTime,
                        isActiveKitchenHurryUpTime
                    } = parsedGeojson.properties || {};

                    const displayHurryUp = moment(isActiveHurryUpTime ? currentTimeForHurryUp : timeForHurryUp, "HH:mm:ss").format("HH:mm");
                    const displayKitchen = moment(isActiveKitchenHurryUpTime ? currentTimeForKitchen : timeForKitchen, "HH:mm:ss").format("HH:mm");

                    const content = `
                        <div>
                            <strong>${name || "Зона доставки"}</strong><br/>
                            ${description || ""}<br/>
                            <b>Интервал для 'поскорее':</b> ${displayHurryUp}<br/>
                            <b>Интервал для кухни:</b> ${displayKitchen}
                        </div>
                    `;

                    const polygon = new window.ymaps.Polygon(
                        fixedCoordinates,
                        {
                            hintContent: content,
                            balloonContent: content,
                        },
                        {
                            strokeColor: fillColor,
                            strokeWidth: 3,
                            fillColor,
                            fillOpacity: 0.3,
                            draggable: false,
                        }
                    );

                    map.geoObjects.add(polygon);
                }
            });
        });
    }, [map, items]);

    return (
        <>
            <MapWrap>
                <Map id="yandex-map" />
            </MapWrap>
        </>
    );
}

const MapWrap = styled.div`
  width: 100vw;
  height: 100vh;
  position: relative;
  border-radius: 6px;
  overflow: hidden;
`;

const Map = styled.div`
  width: 100%;
  height: 100%;
`;
